import React from 'react'
import {connect} from 'react-redux';
import { GrayAreaPanel } from '../../components/MessagePanels/Panels';
import { agencyChangeRequestSelect } from '../../redux/selector/agencyChangeRequestSelector';
import Navigation from '../Navigation';
import TopNavigationBar from '../TopNavigationBar';
// import ReviewForm from "../../components/ReviewForm/ReviewForm"

import './AgencyApplicationChangeRequest.styles.scss'
import { Button } from '../../components/RegularComponents';

const AgencyChangeRequestPage = (props) => {
    const { agencyChangeRequest } = props
    const { primaryAgencyApplication } = agencyChangeRequest

    // const { applicationType, applicationMode } = props.match.params

    return (
        <>
            <Navigation {...props} />
            <div className={"container"}>
                <TopNavigationBar {...props} />
                <div className="row">
                    <div className="col-12">
                        <h2>{primaryAgencyApplication?.businessLicenceData?.businessName ?? ""}</h2>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <GrayAreaPanel>
                            Click on edit to update information and submit your change to Business Licensing team for review.
                        </GrayAreaPanel>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 application-change-request-items">
                        <div className="application-change-request-item">
                            <div className="title">
                                RJSC Profile
                            </div>
                            <div className="item">
                                {/* <ReviewForm data={rjscProfileData} /> */}
                            </div>
                            <div className="action-button">
                                <Button 
                                    id="change-request-rjsc-edit"
                                    buttonType="regular_primary"
                                    text="Edit"
                                    onClick={() => {}}
                                />
                            </div>
                        </div>

                        <div className="application-change-request-item">
                            <div className="title">
                                RJSC Profile
                            </div>
                            <div className="item">
                                {/* <ReviewForm data={rjscProfileData} /> */}
                            </div>
                            <div className="action-button">
                                <Button 
                                    id="change-request-rjsc-edit"
                                    buttonType="regular_primary"
                                    text="Edit"
                                    onClick={() => {}}
                                />
                            </div>
                        </div>
                    </div>

                    
                        

                </div>
            </div>
        </>
    )
}

export default connect(agencyChangeRequestSelect)(AgencyChangeRequestPage);
